
<template>
    <div>
        <!-- 筛选 -->
        <form @submit.prevent="fetchData" class="flex justify-between">
            <el-select v-on:change="fetchData" v-model="form.active" :placeholder="$t('Reception.Fifth.choose_status')" clearable>
                <el-option :label="$t('Setting.all')" :value="null"/>
                <el-option :label="$t('Reception.Fifth.normal')" :value="true"/>
                <el-option :label="$t('Lesson.deleted')" :value="false"/>
            </el-select>
            <div class="flex client-tag-icons" style="margin-top: 20px;">
                <el-tooltip class="item" effect="dark" :content="$t('tooltip.add')" placement="bottom">
                    <div
                        @click="handleEditTag('add')"
                        class="iconfont icon-fitness-tianjiawenjian client-tag-icon"></div>
                </el-tooltip>
                <el-tooltip effect="dark" :content="$t('tooltip.edit')" placement="bottom">
                    <div
                        class="iconfont
                            icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy"
                        @click="handleEditTag('edit')">
                    </div>
                </el-tooltip>
                <el-tooltip effect="dark" :content="$t('tooltip.delete')" placement="bottom">
                    <div
                        class="iconfont icon-fitness-shanchu"
                        @click="handleDeleteTag"></div>
                </el-tooltip>
                <el-tooltip effect="dark" :content="$t('tooltip.refresh')" placement="bottom">
                    <div
                        class="iconfont icon-fitness-huifu1"
                        @click="handleRevertTag">
                    </div>
                </el-tooltip>
            </div>
        </form>
        <!--内容-->
        <el-table
            ref="singleTable"
            :data="list"
            highlight-current-row
            border
            @current-change="handleCurrentChange"
            style="width: 100%;
                margin-top: 20px">
            <el-table-column
                prop="id"
                :label="$t('Contract.Desc.number')"
                width="180"/>
            <el-table-column
                prop="name"
                :label="$t('Contract.Desc.lablecontent')"/>
            <el-table-column
                prop="active"
                :label="$t('Reception.Fourth.status')"
                width="180">
                <template
                    slot-scope="{$index, row}"
                    v-if="row.active !== ''"
                >{{ row.active ? $t('Reception.Fifth.normal') : $t('Lesson.deleted') }}</template>
            </el-table-column>
        </el-table>
        <!-- 弹窗 -->
        <edit-tag :item="currentRow" ref="EditTag" @fetchData="fetchData"/>
    </div>
</template>


<script>
import EditTag from '@/components/Dialog/Setting/EditTag';

export default {
    name: 'client-tag',
    components: {
        EditTag,
    },
    data() {
        return {
            list: [],
            currentRow: null,
            pagination: {
                size: 10,
                total: 0,
            },
            form: {
                active: null,
            },
            item: null,
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            API.get('client-tag/list', {
                params: this.form,
            }).then((res) => {
                this.list = res;
            });
        },
        handleCurrentChange(val) {
            this.currentRow = val;
        },
        // 编辑标签
        handleEditTag(type) {
            if (!this.currentRow && type === 'edit') {
                return $ele.$message(this.$t('Message.select_customer_label'));
            }
            const id = type === 'add' ? '' : this.currentRow.id;
            this.$refs.EditTag.open(id);
        },
        // 删除标签
        handleDeleteTag() {
            if (!this.currentRow) {
                return $ele.$message(this.$t('Message.select_customer_del'));
            }
            $ele.$confirm(this.$t('Message.Alltags_del') +'\n' +
                this.$t('Message.Unable_to_recover'), this.$t('Common.tip'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                API.delete(`client-tag/${this.currentRow.id}/active`).then(() => {
                    $ele.$message.success(this.$t('Message.delete_success'));
                    this.fetchData();
                });
            }).catch(() => {
                $ele.$message.info(this.$t('Common.message.canceldel'));
            });
        },
        // 恢复
        handleRevertTag() {
            if (!this.currentRow) {
                return $ele.$message(this.$t('Message.customer_label_information_restore'));
            }
            $ele.$confirm(this.$t('Message.after_restore') + '\n' +
                this.$t('Message.will_not_restore'), this.$t('Common.tip'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                API.put(`client-tag/${this.currentRow.id}/active`).then(() => {
                    $ele.$message.success(this.$t('Common.message.successRestore'));
                    this.fetchData();
                });
            }).catch(() => {
                $ele.$message.info(this.$t('Common.message.canceldel'));
            });
        },
    },
};
</script>

<style lang="scss">
    .client-tag-icon {
        font-size: 24px;
        color: #697a8e;
    }
    .client-tag-icons {
        .iconfont {
            font-size: 15px;
            margin-right: 10px;
        }
        color: #697a8e;
    }
</style>
